/*
 * T5 (Titipan auditor 26 Okt 2026): alamat Gmail ber-tanda "+" (alias) tidak pernah cocok saat masuk lewat
 * Google — Google mengirim alamat ASLInya — jadi akun itu tidak akan bisa masuk. Peringatan, bukan penolakan.
 */
export function aliasGmailPlus(email) {
  const e = String(email || "").trim().toLowerCase();
  const at = e.lastIndexOf("@");
  if (at < 1) return false;
  const domain = e.slice(at + 1);
  return e.slice(0, at).includes("+") && (domain === "gmail.com" || domain === "googlemail.com");
}
